import React, { useState } from "react";
import {
  Autocomplete,
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { Dialog } from "@mui/material";
import {
  CreateLockerPositionThunk,
  CreateLockerTypeThunk,
} from "../Redux/SettingsModule/SettingsThunks";
import { useDispatch } from "react-redux";

const LockerPositionDialogSmall = ({}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [place, setPlace] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSend = () => {
    dispatch(CreateLockerPositionThunk(place));
    setOpen(false);
  };

  return (
    <Container sx={{ width: "500px" }}>
      <Button
        onClick={() => {
          handleOpen();
        }}
      >
        Dodaj nową pocyje
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle variant="h5">Nowa Pozycja</DialogTitle>
        <DialogContent>
          <DialogContentText>Wprowadz dane</DialogContentText>

          <TextField
            margin="dense"
            id="PositionName"
            label="Nazwa Pozycji"
            fullWidth
            variant="standard"
            onChange={(val) => {
              setPlace(val.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Anuluj</Button>
          <Button onClick={() => handleSend()}>Wyślij</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default LockerPositionDialogSmall;
